import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { f as focusOutline } from '../../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-1m8IJOfp.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { K as KEYBOARD_KEYNAMES } from '../../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-AmBipDtf-AmBipDtf.js';

const NavItem = /*#__PURE__*/styled('li').withConfig({
  componentId: "sc-storm-ui-40013943__sc-1naj74z-0"
})(["display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-content:center;align-items:center;cursor:pointer;column-gap:", ";margin-inline-start:", ";padding-block:", ";padding-inline:", ";border-radius:", ";font:", ";font-weight:", ";color:", ";background-color:", ";:link{text-decoration:none;}:hover{background-color:", ";}:focus-visible{", "}", " ", ""], ({
  theme
}) => theme.spacing.xxxsmall.default, ({
  theme,
  $subItem
}) => $subItem ? theme.spacing.xxsmall.default : '0px', ({
  theme
}) => theme.controls.paddingInline.large.default, ({
  theme
}) => theme.controls.paddingInline.medium.default, ({
  theme
}) => theme.border.radius.small, ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.font.weight.regular, ({
  theme
}) => theme.text.color.default, ({
  theme
}) => theme.selectableContainer.backgroundColor.default, ({
  theme
}) => theme.selectableContainer.backgroundColor.hover, focusOutline, isMobile(css(["font:", ";padding-block:", ";padding-inline:", ";"], ({
  theme
}) => theme.font.text.base.mobile, ({
  theme
}) => theme.controls.paddingInline.large.mobile, ({
  theme
}) => theme.controls.paddingInline.medium.mobile)), ({
  $isActive
}) => $isActive && css(["font-weight:", ";background-color:", ";"], ({
  theme
}) => theme.font.weight.bold, ({
  theme
}) => theme.selectableContainer.backgroundColor.selected));
const NavItemLabel = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-storm-ui-40013943__sc-1naj74z-1"
})(["flex:0 1 auto;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
const SideNavItem = ({
  onClick,
  isActive = false,
  subItem = false,
  children,
  renderStart,
  renderEnd,
  taktId,
  taktValue,
  ...rest
}) => {
  const handleKeyDown = event => {
    const {
      key
    } = event;
    if (key === KEYBOARD_KEYNAMES.ENTER || key === KEYBOARD_KEYNAMES.SPACE) {
      onClick === null || onClick === void 0 || onClick(event);
      event.preventDefault();
    }
  };
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('side-nav-item')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(NavItem, _extends({}, getDataTaktAttributes(), rest, {
    onClick: onClick,
    $isActive: isActive,
    $subItem: subItem,
    tabIndex: 0,
    role: "button",
    onKeyDown: handleKeyDown
  }), renderStart && renderStart(), /*#__PURE__*/React__default.createElement(NavItemLabel, null, children), renderEnd && renderEnd()));
};

export { SideNavItem as S };
//# sourceMappingURL=SideNavItem-ls6rl1Kx.js.map
